import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue"
import { PaymentFormValues } from "@/modules/Missions/components/Payment/CreatePaymentStructureForm.vue"
import { MissionLifecycleFragmentFragment, MissionScopeActivity } from "@/gql"
import MoneyDisplay from "@/components/feature/MoneyDisplay.vue"
import Icon from "@/components/widgets/icons/Icon.vue"
import Header from "@/modules/Missions/components/Payment/SetupPaymentHeader.vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'PreviewPayments',
  props: {
    form: null,
    mission: null,
    getAmountFromPercentage: null,
    attachedDeliverables: null,
    isSubmitting: { type: Boolean },
    submitLabel: { default: "Done" },
    showLinkPayment: { type: Boolean, default: false },
    title: { default: "Review payment set up" }
  },
  emits: ["close", "complete", "gotoDeliverables", "back", "gotoEditPercentages", "linkClientPayment"],
  setup(__props: any, { emit }: { emit: ({
  (e: "close"): void
  (e: "complete"): void
  (e: "gotoDeliverables", paymentIndex: number): void
  (e: "back"): void
  (e: "gotoEditPercentages"): void
  (e: "linkClientPayment", paymentIndex: number): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { form: PaymentFormValues[], mission: MissionLifecycleFragmentFragment, getAmountFromPercentage: (percentage: number) => number, attachedDeliverables?: Record<number, MissionScopeActivity[]>, isSubmitting?: boolean, submitLabel: string, showLinkPayment: boolean, title: string }





const missionContractPayments = computed(() => {
  return props.mission.missionContract?.missionContractPayments
})

return { __sfc: true,props, emit, missionContractPayments, MoneyDisplay, Icon, Header }
}

})